import { computed, inject, Injectable, signal } from '@angular/core';
import { COLUMN_SETTINGS, ColumnSetting, PROJECT_PREFIX } from '@ct/model';

export interface RouteConfig {
  projectPrefix: string;
  columnSettings: ColumnSetting[];
  vesselTypes?: unknown[];
  columns?: unknown[];
}

@Injectable({
  providedIn: 'root',
})
export class RouteConfigService {
  private _config = signal<RouteConfig | null>(null);
  private _initialized = false;
  public readonly config = computed(() => this._config());

  /**
   * Initialize the configuration from the current route's injection tokens.
   * This should be called from components that are loaded within routes
   * that provide the necessary tokens.
   */
  initializeFromRoute(): void {
    if (this._initialized) {
      return;
    }

    try {
      const projectPrefix = inject(PROJECT_PREFIX);
      const columnSettings = inject(COLUMN_SETTINGS);

      this._config.set({
        projectPrefix,
        columnSettings,
      });

      this._initialized = true;
    } catch (error) {
      console.warn('RouteConfigService: Could not initialize from route tokens', error);
    }
  }
}
